import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Checkbox, FormControlLabel } from '@material-ui/core';
import { Button } from 'react-bootstrap';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import SelectBoxComponent from '../../../../SharedModules/SelectBox/SelectBoxWithoutBox';
import FieldSet from './FieldSet';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import { ManufactureTableHead } from './tableHeads';
import {
  getManufacturerList,
  getPlanTypeValues,
  getRebateProgrameList,
  getUnallocatedBalanceReports,
  setSearchInput,
  setUnallocatedBalanceReports,
} from '../store/action';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import { tabHighLigther } from '../../../../SharedModules/utilities/utilities';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';

const UnallocatedBalance = (props) => {
  const gridRef = useRef();
  const dispatch = useDispatch();

  const planTypeList = useSelector(
    (state) => state?.sharedState?.UnallocatedBalanceReducer?.planType
  );

  const manufactureListData = useSelector(
    (state) => state?.sharedState?.UnallocatedBalanceReducer?.manufacturerList
  );
  const { isLoading, searchResult } = useSelector(
    (state) => state?.sharedState?.UnallocatedBalanceReducer
  );
  const {
    used,
    unused,
    lcb,
    opmt,
    rebateProgramNameValue,
    selectedPlanType,
    rebateProgram: rebateProgramValue,
    isAllManufacturersSelected: isAllManufacturersSelectedValue,
    selectedRowIndexValue,
    errors,
  } = useSelector((state) => state?.sharedState?.UnallocatedBalanceReducer);

  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );

  const [radioList, setRadioList] = React.useState([]);

  const [selectList, setSelectList] = React.useState([]);

  const [manufactureList, setManufactureList] = React.useState([]);

  const [planType, setPlanType] = React.useState(selectedPlanType);

  const [rebateProgram, setRebateProgram] = React.useState(rebateProgramValue);

  const [errorList, setErrorList] = React.useState(errors);

  const [fullScreenView, setFullScreenView] = React.useState(false);

  const [searchClicked, setSearchClicked] = React.useState(false);

  // const [rebateProgramName, setRebateProgramName] = React.useState(
  //   rebateProgramNameValue
  // );

  const [c, setC] = React.useState(0);

  const changeFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };

  React.useEffect(() => {
    setErrorList(errors);
  }, [errors]);
  React.useEffect(() => {
    const errors = errorList.filter((error) => error.field !== 'noData');
    if (manufactureListData.length === 0 && c > 1) {
      errors.push({
        field: 'noData',
        message: 'No data found for selected search inputs',
      });
    }
    setC(c + 1);
    setErrorList([...errors]);
    manufactureListData.sort((a, b) =>
      a.mfgId > b.mfgId ? 1 : b.mfgId > a.mfgId ? -1 : 0
    );
    setManufactureList(manufactureListData);
  }, [manufactureListData]);

  // React.useEffect(() => {
  //   const list = rebateProgramListData?.map((val) => ({
  //     ...val,
  //     id: val.rebateProgramCd,
  //     name: `${val.rebateProgramCd} | ${val.shortDescr}`,
  //   }));
  //   if (list.length) {
  //     setSelectList(list);
  //     let tempRebateProgram = list.find(
  //       (item) => item.id === userDefaults.rebateProgramCd
  //     );
  //     setRebateProgram(rebateProgram || tempRebateProgram?.id || '-1');
  //     setRebateProgramName(tempRebateProgram?.name || '');
  //   }
  // }, [rebateProgramListData]);

  const rebatepgmDropdown = async (planType) => {
    let list = await dispatch(getRebateProgrameList(planType));
    list = list?.map((val) => ({
      ...val,
      id: val.rebateProgramCd,
      name: `${val.rebateProgramCd} | ${val.shortDescr}`,
    }));
    // if (list.length) {
    setSelectList(list);
    const tempRebateProgram = list.find(
      (item) => item.id === userDefaults?.rebateProgramCd
    );
    setRebateProgram(rebateProgram || tempRebateProgram?.id || '-1');
    // }
  };
  React.useEffect(() => {
    if (planType) {
      rebatepgmDropdown(planType);
      const errors = errorList.filter((e) => e.field !== 'noData');
      setErrorList([...errors]);
    }
  }, [planType]);

  React.useEffect(() => {
    if (planTypeList?.PLAN_TYPE_CD?.length > 0) {
      const planList = planTypeList.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });
      setRadioList([
        ...planList.filter((obj) => obj.name === 'Medicaid'),
        ...planList.filter((obj) => obj.name !== 'Medicaid'),
      ]);
      const tempPlanType = planList.find(
        (item) => item.value === userDefaults?.planTypeCd
      );
      setPlanType(planType || tempPlanType?.value);
    }
  }, [planTypeList]);

  React.useEffect(() => {
    if (errorList.length > 0) {
      tabHighLigther('/unallocatedBalance', true);
    } else {
      tabHighLigther('/unallocatedBalance', false);
    }
  }, [JSON.stringify(errorList)]);

  const [checkboxValues, setCheckboxValues] = React.useState({
    isAllManufacturersSelected: isAllManufacturersSelectedValue,
    used: used,
    unused: unused,
    lcb: lcb,
    opmt: opmt,
  });

  const [selectedRows, setSelectedRows] = React.useState([]);
  const onSelectionChanged = (e) => {
    const selectedRows = e.api?.getSelectedRows();
    setSelectedRows(selectedRows);
    const errors = errorList.filter(
      (error) => error.field !== 'manufaturerError'
    );
    setErrorList([...errors]);
  };
  const handleSearchClick = () => {
    const { used, unused, lcb, opmt, isAllManufacturersSelected } =
      checkboxValues;

    const sRows = isAllManufacturersSelected
      ? manufactureList
      : selectedRows || [];
    const selectedRowIndex = [];
    const ids = selectedRows?.map((item) => item.mfgId);
    for (let i = 0; i < manufactureList.length; i++) {
      if (ids.indexOf(manufactureList[i].mfgId) !== -1) {
        selectedRowIndex.push(i);
      }
    }
    const errors = [];
    if (!used && !unused) {
      errors.push({
        field: 'balanceStatus',
        message: 'You have not selected either used or unused balance status.',
      });
    }
    if (!lcb && !opmt) {
      errors.push({
        field: 'balanceType',
        message: 'You have not selected either LCB or OPMT balance type.',
      });
    }
    if (sRows.length === 0 && !checkboxValues.isAllManufacturersSelected) {
      errors.push({
        field: 'manufaturerError',
        message: 'Manufacturer is required',
      });
    }
    if (rebateProgram === '-1') {
      errors.push({
        field: 'rebateProgram',
        message: 'Rebate program is required.',
      });
    }
    if (errorList.find((e) => e.field === 'noData')) {
      errors.push({
        field: 'noData',
        message: 'No data found for selected search inputs',
      });
    }
    setErrorList(errors);
    sRows.sort((a, b) => (a.mfgId > b.mfgId ? 1 : b.mfgId > a.mfgId ? -1 : 0));

    // Variable to get fullname of rebate program from rebate program list(selectList)
    let rebateProgramName =
      selectList.find((item) => item.rebateProgramCd === rebateProgram) || {};
    rebateProgramName = `${rebateProgramName?.rebateProgramCd} - ${
      rebateProgramName?.shortDescr || ''
    }`;
    dispatch(
      setSearchInput({
        used,
        unused,
        lcb,
        opmt,
        errors,
        selectedPlanType: planType,
        rebateProgram,
        selectedRows: sRows,
        rebateProgramName,
        isAllManufacturersSelected,
        selectedRowIndexValue: selectedRowIndex,
        displayObj: {
          used,
          unused,
          lcb,
          opmt,
          selectedRows: sRows,
          rebateProgram,
          rebateProgramName,
        },
      })
    );

    if (
      sRows.length > 1 &&
      (used || unused) &&
      (lcb || opmt) &&
      rebateProgram !== '-1'
    ) {
      dispatch(setUnallocatedBalanceReports([]));
      const updateTabs =
        JSON.parse(localStorage.getItem('tabItemsData')) === null
          ? []
          : JSON.parse(localStorage.getItem('tabItemsData'));

      updateTabs.push({
        navTo: '/unallocated-balance-report',

        value: 'Display Unallocated Balance Report',
      });

      localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
      if (props?.history) {
        props.history.push({
          pathname: '/unallocated-balance-report',
        });

        dispatch(clearReduxForFilterAndSort('/unallocated-balance-report'));
      }
    }

    if (
      sRows.length === 1 &&
      (used || unused) &&
      (lcb || opmt) &&
      rebateProgram !== '-1'
    ) {
      setSearchClicked(true);
      dispatch(setUnallocatedBalanceReports([]));
      dispatch(
        getUnallocatedBalanceReports({
          asMfg: [sRows[0]?.mfgId],
          alUsed: used && unused ? 2 : used ? 0 : 1,
          asType: lcb && opmt ? 'ALL' : lcb ? 'LCB' : 'OPMT',
          asRpc: rebateProgram,
        })
      );
    }
    // }, 2000);
  };
  if (searchResult.length > 0 && searchClicked) {
    setSearchClicked(false);
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) === null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));

    updateTabs.push({
      navTo: '/unallocated-balance-report',

      value: 'Display Unallocated Balance Report',
    });

    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    if (props?.history) {
      props.history.push({
        pathname: '/unallocated-balance-report',
      });

      dispatch(clearReduxForFilterAndSort('/unallocated-balance-report'));
    }
  }

  React.useEffect(() => {
    dispatch(getPlanTypeValues({ codeDomainList: ['PLAN_TYPE_CD'] }));
  }, []);

  React.useEffect(() => {
    if (rebateProgram && rebateProgram != '-1' && planType)
      dispatch(
        getManufacturerList({
          mfgTypeCd: planType === 'ST' || planType === 'FD' ? 'G' : 'C',
          asRpc: rebateProgram,
        })
      );
  }, [rebateProgram, planType]);
  
  //remove no data error msg
  React.useEffect(() => {
    setSearchInput([]);
  }, [rebateProgram, planType, planTypeList, manufactureListData, checkboxValues.used, checkboxValues.unused, checkboxValues.lcb, checkboxValues.opmt]);
const [gridApi, setGridApi] = useState(null);
const onGridReady = (params) => {
  setGridApi(params.api);
};
useEffect(() => {
  if (!gridApi || manufactureList.length === 0) return;
  const selectedRows = gridApi.getSelectedRows();
  if (selectedRows.length > 0) return;
  const firstNode = gridApi.getDisplayedRowAtIndex(0);
  if (firstNode) {
    firstNode.setSelected(true);
    onSelectionChanged({ api: gridApi }); 
  }
}, [gridApi, manufactureList]);

  return (
    <div className="tabs-container">
      <Spinner load={isLoading} />

      <CustomSeparator parent1="Detail Reports" parent2="Unallocated Balance" />

      <DisplayErrorMessages errorMessages={errorList.map((l) => l.message)} />

      <div className="tab-body">
        {!fullScreenView && (
          <>
            <div className="row">
              <div className="col-4 frr-two-col-radio">
                <RadioGroupComponent
                  data-testid="ub-radio-btn-plan"
                  id="filter-plan-by-radio-btn-action"
                  labelName="Plan Type"
                  required
                  optionList={radioList || []}
                  defaultValue={planType}
                  filterAction={(value) => {
                    setPlanType(value);
                    setRebateProgram('-1');
                    const errors = errorList.filter(
                      (error) => error.field !== 'rebateProgram'
                    );
                    setErrorList([...errors]);
                  }}
                  className="log-batch-filter-radio frr-checkInvoiceRadio"
                />
              </div>
              <div className="col-4">
                <>
                  <SelectBoxComponent
                    data-testid="ub-radio-btn-rebateprog"
                    id="filter-plan-by-radio-btn-action"
                    labelName="Rebate Program"
                    required
                    select
                    selectOne
                    optionList={selectList || []}
                    defaultValue={rebateProgram}
                    filterAction={(value) => {
                      setRebateProgram(value);
                      // setRebateProgramName(value);
                      const errors = errorList.filter(
                        (error) => error.field !== 'rebateProgram'
                      );
                      setErrorList([...errors]);
                    }}
                    isError={
                      errorList.filter(
                        (error) => error.field === 'rebateProgram'
                      ).length
                    }
                  />
                </>
              </div>
            </div>
            <div className="row" style={{ marginTop: 15 }}>
              <div className="col-4">
                <>
                  <FieldSet
                    label="Balance Status"
                    isError={
                      errorList.filter(
                        (error) => error.field === 'balanceStatus'
                      ).length
                    }
                    required
                  >
                    <div className="filter-checkbox">
                      <FormControlLabel
                        control={
                          <>
                            <div style={{ width: 125, marginLeft: 5 }}>
                              Used:{' '}
                            </div>
                            <Checkbox
                              data-testid="ub-checkbox-onchange"
                              color="primary"
                              onChange={(e) => {
                                setCheckboxValues({
                                  ...checkboxValues,
                                  used: !checkboxValues.used,
                                });
                                const errors = errorList.filter(
                                  (error) => error.field !== 'balanceStatus'
                                );
                                setErrorList([...errors]);
                              }}
                              checked={checkboxValues.used}
                            />
                          </>
                        }
                      />
                    </div>
                    <div className="filter-checkbox">
                      <FormControlLabel
                        control={
                          <>
                            <div style={{ width: 125, marginLeft: 5 }}>
                              Unused:{' '}
                            </div>
                            <Checkbox
                              color="primary"
                              onChange={(e) => {
                                setCheckboxValues({
                                  ...checkboxValues,
                                  unused: !checkboxValues.unused,
                                });
                                const errors = errorList.filter(
                                  (error) => error.field !== 'balanceStatus'
                                );
                                setErrorList([...errors]);
                              }}
                              checked={checkboxValues.unused}
                            />
                          </>
                        }
                      />
                    </div>
                  </FieldSet>
                </>
              </div>
              <div className="col-4">
                <>
                  <FieldSet
                    label="Balance Type"
                    isError={
                      errorList.filter((error) => error.field === 'balanceType')
                        .length
                    }
                    required
                  >
                    <div className="filter-checkbox">
                      <FormControlLabel
                        control={
                          <>
                            <div style={{ width: 125, marginLeft: 5 }}>
                              LCB:
                            </div>
                            <Checkbox
                              color="primary"
                              onChange={(e) => {
                                setCheckboxValues({
                                  ...checkboxValues,
                                  lcb: !checkboxValues.lcb,
                                });
                                const errors = errorList.filter(
                                  (error) => error.field !== 'balanceType'
                                );
                                setErrorList([...errors]);
                              }}
                              checked={checkboxValues.lcb}
                            />
                          </>
                        }
                      />
                    </div>
                    <div className="filter-checkbox">
                      <FormControlLabel
                        control={
                          <>
                            <div style={{ width: 125, marginLeft: 5 }}>
                              OPMT:{' '}
                            </div>
                            <Checkbox
                              color="primary"
                              onChange={(e) => {
                                setCheckboxValues({
                                  ...checkboxValues,
                                  opmt: !checkboxValues.opmt,
                                });
                                const errors = errorList.filter(
                                  (error) => error.field !== 'balanceType'
                                );
                                setErrorList([...errors]);
                              }}
                              checked={checkboxValues.opmt}
                            />
                          </>
                        }
                      />
                    </div>
                  </FieldSet>
                </>
              </div>

              <div className="col-4">
                <FieldSet
                  label="Manufacturers"
                  isError={
                    errorList.filter(
                      (error) => error.field === 'manufaturerError'
                    ).length
                  }
                >
                  <div className="filter-checkbox">
                    <FormControlLabel
                      control={
                        <>
                          <div style={{ width: 175, marginLeft: 5 }}>
                            All Manufacturers:
                          </div>
                          <Checkbox
                            color="primary"
                            onChange={(e) => {
                              setCheckboxValues({
                                ...checkboxValues,
                                isAllManufacturersSelected:
                                  !checkboxValues.isAllManufacturersSelected,
                              });
                              const errors = errorList.filter(
                                (error) => error.field !== 'manufaturerError'
                              );
                              setErrorList([...errors]);
                              const elem = document.getElementById('abc');
                              if (
                                elem &&
                                checkboxValues.isAllManufacturersSelected
                              ) {
                                // setTimeout(() => {
                                //   elem.scrollIntoView();
                                // }, 1000);
                                requestAnimationFrame(() => {
                                  elem.scrollIntoView();
                                });
                              }
                            }}
                            checked={checkboxValues.isAllManufacturersSelected}
                          />
                        </>
                      }
                    />
                  </div>
                </FieldSet>
              </div>
            </div>
            <div className="row" style={{ marginTop: 30 }}>
              <div className="btn-wrapper col-12">
                <Button
                  onClick={handleSearchClick}
                  className="btn btn-success btn-search float-right"
                  data-tesid="search"
                >
                  <SVGComponent iconName="Icon-search" /> Search
                </Button>
              </div>
            </div>
          </>
        )}
        <div className="row" id="abc" style={{ marginTop: 15 }}>
          {!checkboxValues.isAllManufacturersSelected ? (
            <div className="unallocated" style={{ width: '100vw' }}>
              <TableGridWithFeatures
                onSelectionChanged={onSelectionChanged}
                ref={gridRef}
                gridCall={onGridReady}
                gridHeight={viewPortHeight_355}
                selectRowIndex={selectedRowIndexValue}
                columnDefs={ManufactureTableHead}
                rowData={manufactureList}
                rowSelection="multiple"
                rowMultiSelectWithClick
                data-testid="onEditingStopped"
                enterMovesDown
                showResetFilter={false}
                // suppressCellFocus={true}
                hideTotalCount={false}
                exportFile
                fileName="Manufacturer List"
                fullScreenView={fullScreenView}
                handleFullScreenViewClick={changeFullScreenView}
                // hideColumnsInPdf={true}
                // suppressRowClickSelection //To disable row selection on click of the row
              />
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default UnallocatedBalance;
